/**
 * Created by Kevin on 2016-02-24.
 */
angular.module('flipto.core.enums', []);